var map = {
	"./avatar.png": 4211,
	"./banner-image.svg": 3924,
	"./calendar-filter.svg": 6015,
	"./comissao.svg": 3568,
	"./filter.svg": 1420,
	"./ftd.svg": 8420,
	"./ganhos.svg": 5418,
	"./icon.png": 3967,
	"./icon.svg": 6445,
	"./icon24.png": 4317,
	"./icon512.png": 935,
	"./indicados.svg": 9860,
	"./ios/ios-1.png": 241,
	"./ios/ios-2.png": 5578,
	"./ios/ios-3.png": 7155,
	"./ios/ios-4.png": 6988,
	"./logo.png": 3153,
	"./notification-bell.png": 7339,
	"./notification-bell.svg": 7967,
	"./novidade.svg": 8432,
	"./qtd-comissao.svg": 2522,
	"./refresh.png": 8995,
	"./reload-circular-arrow-svgrepo-com.svg": 7412,
	"./tailwind.css": 5357,
	"./total-deposito.svg": 5864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;